export const NAME = 'campaignManagement-campaignDetail';
